import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import Settings from "../views/Settings.vue";

const routes = [
  {
    path: "/",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/play",
    name: "Play",
    // route level code-splitting
    // this generates a separate chunk (play.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "play" */ "../views/Play.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "highscore" */ "../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === "Play" && !store.getters.getGameStatus) {
    next("/");
  } else {
    next();
  }
});

export default router;
